import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { ChevronDown, ChevronUp, Calendar, Clock, CheckCircle2, Gift, CalendarPlus, Trash2 } from 'lucide-react';
import { getTierBadge, getTrialInfo, formatDate } from './adminHelpers';

export const AdminUserMiniCard = ({ u, canModify, isSuperAdmin, onExtend, onDelete }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="p-3 sm:p-4" data-testid={`section-user-${u.id}`}>
      <div className="flex items-center justify-between cursor-pointer" onClick={() => setExpanded(!expanded)}>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <p className="text-white text-sm font-medium">{u.name}</p>
            {getTierBadge(u)}
          </div>
          <p className="text-slate-400 text-xs truncate">{u.email}</p>
        </div>
        {expanded ? <ChevronUp className="h-4 w-4 text-slate-400" /> : <ChevronDown className="h-4 w-4 text-slate-500" />}
      </div>
      {expanded && (
        <div className="mt-3 p-3 bg-slate-700/30 rounded-lg border border-slate-600 space-y-2">
          <div className="flex items-center gap-3 text-xs text-slate-400 flex-wrap">
            <span className="flex items-center gap-1">
              <Calendar className="h-3 w-3" />
              Joined {formatDate(u.created_at)}
            </span>
            <span className="flex items-center gap-1">
              <Clock className="h-3 w-3" />
              {getTrialInfo(u)}
            </span>
            {u.is_beta_user && (
              <span className="flex items-center gap-1 text-emerald-400">
                <CheckCircle2 className="h-3 w-3" />Beta
              </span>
            )}
            {isSuperAdmin && (
              <span className="flex items-center gap-1 text-slate-500">
                <Gift className="h-3 w-3" />
                {u.max_referrals || 6} invites / {u.referral_reward_days || 30}d reward
              </span>
            )}
          </div>
          {canModify && (
            <div className="flex items-center gap-2 pt-1">
              <Button size="sm" variant="ghost"
                onClick={(e) => { e.stopPropagation(); onExtend(); }}
                className="text-emerald-400 hover:text-emerald-300 hover:bg-emerald-500/10 text-xs h-7 px-2">
                <CalendarPlus className="h-3 w-3 mr-1" />Adjust Trial
              </Button>
              {isSuperAdmin && (
                <Button size="sm" variant="ghost"
                  onClick={(e) => { e.stopPropagation(); onDelete(); }}
                  className="text-red-400 hover:text-red-300 hover:bg-red-500/10 text-xs h-7 px-2">
                  <Trash2 className="h-3 w-3 mr-1" />Delete
                </Button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
